// extracted by mini-css-extract-plugin
export default {"Title":"PackConfiguration_Title__nhCag","Row":"PackConfiguration_Row__On7hd","Tag":"PackConfiguration_Tag__IzWCs"};